/** Take in an array.. target one entry of the array.. insert a payload before this entry */
export function addEntryBeforeEntry(originalArray = [], target, payload) {
  const index = originalArray.indexOf(target);

  //If the target is not found, just return the original.
  if (index === -1) {
    return originalArray;
  }

  //Insert payload item at `index` position.
  let newArray = [...originalArray];
  newArray.splice(index, 0, payload);
  return newArray;
}



// WEBPACK FOOTER //
// ./src/helpers/add-entry-before-entry.js